import React from "react";

interface PageTemplateProps {
  children: React.ReactNode;
}

const PageTemplate = ({ children }: PageTemplateProps) => {
  return (
    <div className="container p-4 mx-auto">
      {children}
    </div>
  );
};

export default PageTemplate; 